/**
 * Initialize the service-worker which enables offline operation.
 */
export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      // Path is relative to origin, not to src/
      // const workerUrl = new URL("/service-worker.js", import.meta.url);
      const registration = await navigator.serviceWorker.register("/service-worker.js", {
        scope: "/",
      });
      console.log(`Offline cache status=${getRegStatus(registration)}`);
    } catch (error) {
      console.error(`Service worker Registration failed with ${error}`);
    }
  }
};

function getRegStatus(reg: ServiceWorkerRegistration) {
  if (reg.installing) {
    return "installing";
  } else if (reg.waiting) {
    return "installed";
  } else if (reg.active) {
    return "active";
  }
  return "unknown";
}
